import { categoryList } from "@/mocks/categories";

export default function AllCategories() {
  return (
    <section className="w-full py-16 md:py-20 bg-secondary-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            All{" "}
            <span className="text-primary-500">Product Categories</span>
          </h2>
          <p className="mt-3 text-foreground-600 max-w-[560px] mx-auto text-sm md:text-base">
            Every pandabuy spreadsheet category at your fingertips — click any category to start browsing
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {categoryList.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-3 p-5 rounded-2xl bg-background-50 border border-background-200/60 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer text-center"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-secondary-100 group-hover:bg-primary-100 transition-colors duration-200">
                <span className="text-xl md:text-2xl font-heading font-bold text-primary-500">
                  {cat.name.charAt(0)}
                </span>
              </div>
              <div>
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base whitespace-nowrap group-hover:text-primary-600 transition-colors">
                  {cat.name}
                </h3>
                <p className="text-[11px] md:text-xs text-foreground-500 mt-1">{cat.updateFrequency}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}